import Link from "next/link";
import { useState } from "react";
import clsx from "clsx";
import FooterLocalBusinessContacts from "~/components/common/footerLocalBusinessContacts";
import styles from "./Footer.module.scss";

const menus = {
  catalog: "catalog",
  shop: "shop",
  clients: "clients",
  partners: "partners",
};

export default function Footer({ host = "" }) {
  const [menuState, setMenuState] = useState("");

  return (
    <div className={styles.Footer}>
      <div className="container">
        <div className={styles.Colomns}>
          <div>
            <FooterLocalBusinessContacts />

            <div className={styles.Soc}>
              <span>Мы в соцсетях</span>
              <div className={styles.SocList}>
                <Link href="https://vk.com/farkopru">
                  <a target="_blank" rel="nofollow">
                    <img src="/soc/3.svg"></img>
                  </a>
                </Link>
                <Link href="https://rutube.ru/channel/33712357/">
                  <a target="_blank" rel="nofollow">
                    <img src="/soc/4.svg"></img>
                  </a>
                </Link>
              </div>
            </div>
          </div>
          <div
            className={clsx(
              styles.MenuBlock,
              menuState === menus.shop && styles.MenuBlockActive,
            )}
          >
            <span
              className={styles.ColomnTitle}
              onClick={() => {
                setMenuState(menuState === menus.shop ? "" : menus.shop);
              }}
            >
              Магазин
            </span>
            <ul>
              <li>
                <Link href="/about/">О компании</Link>
              </li>
              {["msk.farkop.ru", "spb.farkop.ru"].includes(host) && (
                <li>
                  <Link href="/services/">Услуги</Link>
                </li>
              )}
              <li>
                <Link href="/reviews/">Отзывы</Link>
              </li>
              <li>
                <Link href="/articles/">Статьи и новости</Link>
              </li>
              <li>
                <Link href="/contacts/">Контакты</Link>
              </li>
              {["msk.farkop.ru", "spb.farkop.ru"].includes(host) && (
                <li>
                  <Link href="/shops/">Магазины</Link>
                </li>
              )}
            </ul>
          </div>
          <div
            className={clsx(
              styles.MenuBlock,
              menuState === menus.clients && styles.MenuBlockActive,
            )}
          >
            <span
              className={styles.ColomnTitle}
              onClick={() => {
                setMenuState(menuState === menus.clients ? "" : menus.clients);
              }}
            >
              Покупателям
            </span>
            <ul>
              <li>
                <Link href="/faq/">Вопросы и ответы</Link>
              </li>
              <li>
                <Link href="/payment/">Оплата</Link>
              </li>
              <li>
                <Link href="/delivery/">Доставка</Link>
              </li>
              <li>
                <Link href="/refund/">Возврат товара</Link>
              </li>
              <li>
                <Link href="/warranty/">Гарантия</Link>
              </li>
              <li>
                <Link href="/certificates/">Сертификаты</Link>
              </li>
            </ul>
          </div>
          <div
            className={clsx(
              styles.MenuBlock,
              menuState === menus.partners && styles.MenuBlockActive,
            )}
          >
            <span
              className={styles.ColomnTitle}
              onClick={() => {
                setMenuState(
                  menuState === menus.partners ? "" : menus.partners,
                );
              }}
            >
              Партнеры
            </span>
            <ul>
              <li>
                <Link href="/partners/cooperation/">Сотрудничество</Link>
              </li>
              <li>
                <Link href="/partners/opt/">Оптовые продажи</Link>
              </li>
              <li></li>
            </ul>
            <div className={styles.Vidjets}>
              <iframe
                src="https://yandex.ru/sprav/widget/rating-badge/1147929148"
                width="150"
                height="50"
                frameBorder="0"
              />

              <a
                className={styles.Ozon}
                href="https://www.ozon.ru/seller/farkop-ru-174926/products/?miniapp=seller_174926"
                target="_blank"
                rel="noreferrer"
              >
                Мы на
                <img src="/ozon.png" />
              </a>
              <a
                className={styles.Drive2}
                href="https://www.drive2.ru/users/farkopru/"
                target="_blank"
                rel="noreferrer"
              >
                <img src="/drive2.png" />
              </a>
            </div>
          </div>
        </div>

        {host === "msk.farkop.ru" && (
          <div className={styles.Link}>
            <a href="https://spb.farkop.ru/">
              Купить фаркоп с установкой можно так же в Санкт-Петербурге
            </a>
          </div>
        )}
        {host === "spb.farkop.ru" && (
          <div className={styles.Link}>
            <a href="https://msk.farkop.ru/">
              Купить фаркоп с установкой можно так же в Москве
            </a>
          </div>
        )}

        <div className={styles.Req}>
          Индивидуальный предприниматель Асадуллин Ринат Расимович
          <br />
          ИНН: 110603860118
          <br />
          ОГРНИП: 317784700336405
          <br />
          192249, Российская Федерация, г. Санкт-Петербург, проспект
          Александровской Фермы, д. 29, лит. ВГ
          <br />
        </div>

        <div className={styles.Privacy}>
          <Link href="/privacy/">Политика конфиденциальности</Link>
        </div>

        <div className={styles.Copy}>
          <div>© 2010–{new Date().getFullYear()} Фаркоп.ру</div>
          <div className={styles.Payments}>
            <img src="/payments/1.png" />
            <img src="/payments/2.png" />
            <img src="/payments/3.png" />
            <img src="/payments/4.png" />
            <img src="/payments/5.png" />
            <img src="/payments/7.png" />
            <img src="/payments/8.png" />
          </div>
        </div>
        <div className={styles.Info}>
          Вся информация на данном сайте несёт исключительно информационный
          характер и ни при каких условиях не является публичной офертой,
          определяемой положениями Статьи 437 (2) ГК РФ.
        </div>
      </div>
    </div>
  );
}
